import { useContext, useEffect, useState } from 'react'
import { SearchContext, SearchFilterKey, usePage } from 'state'

export const useLoadSearch = ({ filter }: { filter: SearchFilterKey }) => {
  const [showSearch, setShowSearch] = useState(false)
  const { header, setHeader } = usePage()
  const searchContext = useContext(SearchContext)
  const { setActiveFilter } = searchContext

  useEffect(() => {
    setActiveFilter(filter)
  }, [setActiveFilter, filter])

  // Header need to be hidden when the searchbar is moved to the top of the page
  useEffect(() => {
    if (showSearch && !header.hidden) {
      setHeader({ ...header, hidden: true })
    } else if (!showSearch && header.hidden) {
      setHeader({ ...header, hidden: false })
    }
  }, [header, showSearch, setHeader])

  return { showSearch, setShowSearch, ...searchContext }
}
